import * as React from "react";
import { useSelector } from "react-redux";
import { Form, InputOnChangeData, Grid } from "semantic-ui-react";

import { State as RouterState } from "redux-little-router";

import "./styles/login.scss";

export const LoginPage: React.FunctionComponent = () => {
    const redirectUrl = useSelector((state: RouterState) => state.router.query?.redirectUrl);
    const [emailAddress, setEmailAddress] = React.useState<string>("");

    const onChangeEmail = (_event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        setEmailAddress(data.value);
    };

    return (
        <>
            <Grid container padded="vertically" columns="equal" verticalAlign="middle">
                <Grid.Row>
                    <Grid.Column >
                        <img className="oh-logo" src="/assets/Optima_Health_Logo.svg" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row textAlign="center">
                    <Grid.Column >
                        <img className="myoh-logo" src="/assets/myoh_Logo_Manager_RGB_Pos.svg" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                    </Grid.Column>
                    <Grid.Column width={6} textAlign="left">
                        <Grid.Row>
                            <div className="sign-in">Sign in</div>
                        </Grid.Row>
                        <Grid.Row >
                            <div>Please enter your email address to continue</div>
                        </Grid.Row>
                        <Grid.Row>
                            <Form action="/account/login" className="login-form">
                                <input hidden name="redirectUrl" value={redirectUrl} />
                                <Form.Field inline>
                                    <Form.Input
                                        action="Login"
                                        name="loginHint"
                                        placeholder="Enter your email address..."
                                        onChange={onChangeEmail}
                                        value={emailAddress}
                                        required
                                    />
                                </Form.Field>
                            </Form>
                        </Grid.Row>
                        <Grid.Row>
                            <div>
                                To register for the first time you must receive an email from your system administrator.
                                Please contact your HR team or
                                <strong><a href="mailto:myOHsupport@optimahealth.co.uk?Subject=myOH%20Account"> myOHsupport@optimahealth.co.uk </a></strong>
                                if you have not yet received an email.
                            </div>
                        </Grid.Row>
                    </Grid.Column>
                </Grid.Row>
            </Grid>

        </>
    );
};
